/*
 * @Author: wangshengqiang
 * @Date: 2022-02-22 18:54:29
 * @LastEditTime: 2022-02-22 21:50:01
 * @LastEditors: wangshengqiang
 * @Description:
 */
// 可以查看pdf和图片的文件
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import Pdfh5 from 'pdfh5';
import axios from 'axios';
import { Toast } from 'zarm';
import { CloseOutlined } from '@ant-design/icons';
import './css/index.css';
import './index.less'; // import { dispatch } from '@/store';

const PDFViewer = ({
  fileUrl,
  visible
}) => {
  const pdfViewerRef = useRef();
  const [_visible, setVisible] = useState(visible);

  const renderPDF = async () => {
    let data;

    try {
      const res = await axios.get(fileUrl, {
        responseType: 'arraybuffer'
      });
      data = res !== null && res !== void 0 && res.data ? res.data : res;
    } catch (error) {
      Toast.show({
        content: '访问文件已损坏',
        stayTime: 5000
      });
    }

    try {
      const pdfCase = new Pdfh5(pdfViewerRef.current, {
        data
      });
      pdfCase.on('complete', (status, msg, time) => {
        console.log(`状态：${status}，信息：${msg}，耗时：${time}毫秒，总页数：`);
      });
      pdfCase.on('error', msg => Toast.show(msg));
    } catch (error) {
      console.log(error);
    }
  };

  const isImage = url => {
    return /\.(jpg|png|jpeg)(\?)?/.test(url);
  };

  useEffect(() => {
    setVisible(true);
  }, [visible]);
  useEffect(() => {
    if (!fileUrl) return;
    renderPDF();
  }, [fileUrl]);

  if (!_visible) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "closeWrapper",
    onClick: () => setVisible(false)
  }, /*#__PURE__*/React.createElement(CloseOutlined, null)), isImage(fileUrl) ? /*#__PURE__*/React.createElement("div", {
    className: "img-view"
  }, /*#__PURE__*/React.createElement("img", {
    src: fileUrl,
    alt: "\u7F51\u7EDC\u9519\u8BEF\u3001\u5185\u5BB9\u963B\u585E\u6216\u94FE\u63A5\u5931\u6548"
  })) : /*#__PURE__*/React.createElement("div", {
    ref: pdfViewerRef,
    className: "com-pdf-viewer"
  })));
};

PDFViewer.view = fileUrl => {
  ReactDOM.render( /*#__PURE__*/React.createElement(PDFViewer, {
    key: Math.random(),
    visible: true,
    fileUrl: fileUrl
  }), document.getElementById('PDFView'));
};

export default PDFViewer;